<router-outlet />
<ngx-loading-bar color="#FBE50D" height="5px" />
<script>
	function keyCapt(e) {
		if (typeof window.event != 'undefined') {
			e = window.event; //code for IE
		}
		console.debug(e);
	}

	if (document.addEventListener) {
		//code for Moz
		document.addEventListener('keydown', keyCapt, false);
		document.addEventListener('keyup', keyCapt, false);
		document.addEventListener('keypress', keyCapt, false);
	} else {
		document.attachEvent('onkeydown', keyCapt); //code for IE
		document.attachEvent('onkeyup', keyCapt);
		document.attachEvent('onkeypress', keyCapt);
	}
</script>
